import { render } from "./bank-transfer.vue?vue&type=template&id=85ecee24&scoped=true"
import script from "./bank-transfer.vue?vue&type=script&lang=js"
export * from "./bank-transfer.vue?vue&type=script&lang=js"

import "./bank-transfer.vue?vue&type=style&index=0&id=85ecee24&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ecee24"]])

export default __exports__